import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { EnvironmentService } from '@indutrust/shared-env';
import type { Technology } from '@indutrust/shared-model';
import { BaseApiClient } from '@indutrust/shared-model';
import { legacyToTechnology } from './legacy-technology.mapper';

/**
 * Technology catalog client. Maps legacy `sub_technologies` leaves onto
 * the domain `capabilities` field so the factory capability picker can
 * consume a single leaf list.
 */
@Service()
export class TechnologyApiClient extends BaseApiClient<Technology> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template = {};

  protected override fromWire(wire: unknown): Technology {
    return legacyToTechnology(wire);
  }

  get url(): string {
    return `${this.envService.getApiUrl()}/technologies`;
  }
}
